<section *ngIf="userService.hasAdminDisplay()" class="admin-header">
    <div class="container" *ngIf="userService.isUserImpersonated()">
        <p class="impersonate-msg">
            Impersonating
            <span *ngIf="!userService.isImpersonatedUserActive()"> inactive</span>
            <span *ngIf="userService.isAdmin()"> staff</span> user
        </p>
    </div>
    <div class="container" *ngIf="!userService.isUserImpersonated()">
        <a href="/admin">Admin Home</a>
        <a *ngFor="let link of links" [href]="link.url">{{ link.title }} </a>
        <span *ngIf="isUnpublishedPreview">NOT PUBLISHED YET </span>
        <p class="helptext">
            As an administrative user, you may access the Content Management System for PBS
            LearningMedia
        </p>
        <div class="float-right">
            <div *ngIf="version" class="version">{{ version }}</div>
        </div>
    </div>
</section>
